// 印刷ボタン
// ブラウザの印刷ダイアログを開き、ユーザーが「PDFとして保存」を選択して PDF 化する
export default function PrintButton({ label = '印刷 / PDF' }: { label?: string }) {
  return (
    <button onClick={() => window.print()} title="ブラウザの印刷ダイアログから「PDFとして保存」を選択">
      {label}
    </button>
  );
}
